import {
  canAccessDepartmentResource,
  hasAnyDepartmentAccess,
  hasAnyDepartmentWriteAccess,
  isDepartmentUser,
} from '@/helpers/departmentPermissions';
import { checkUserPermissions } from './checkUserPermissions';
import { PermissionDTO } from '@/api/trafikportalen';

interface ViewPermissionsProps {
  children: React.ReactNode;
  permission: PermissionDTO;
  isSysadmin?: boolean;
  departmentId?: string;
}

export const ViewPermissions = ({
  children,
  permission,
  departmentId,
  isSysadmin,
}: ViewPermissionsProps) => {
  if (isSysadmin !== undefined) {
    const userIsSysadmin = checkUserPermissions({
      permission: 'tenant:viewer',
    });

    if (isSysadmin !== userIsSysadmin) {
      return null;
    }
  }

  if (checkUserPermissions({ permission })) {
    return children;
  }

  if (isDepartmentUser()) {
    if (
      departmentId &&
      typeof permission === 'string' &&
      permission.startsWith('organization:')
    ) {
      const requireWrite = permission.includes('editor');
      if (canAccessDepartmentResource(departmentId, requireWrite)) {
        return children;
      }
    }

    if (permission === 'organization:viewer' && hasAnyDepartmentAccess()) {
      return children;
    }

    if (permission === 'organization:editor' && hasAnyDepartmentWriteAccess()) {
      return children;
    }
  }

  return null;
};
